/**
 * What every cell renderer in the P&L grid needs to know about the sheet it
 * sits in, without each row threading it down: which months have posted
 * actuals (an actual-based column on an open month reads "—", not $0), and
 * whether numerals drop the currency symbol (the New look keeps it in the
 * column header instead).
 */

import { createContext, useContext } from 'react';

export interface GridDisplay {
  closedMonthSet: Set<string>;
  hideSymbol: boolean;
}

export const GridDisplayContext = createContext<GridDisplay>({ closedMonthSet: new Set(), hideSymbol: false });

export function useGridDisplay(): GridDisplay {
  return useContext(GridDisplayContext);
}

const MONTH_KEYS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

/** Columns that only mean something once the month has an actual to read. */
export const ACTUAL_BASED_KEYS = new Set(['actual', 'var', 'vsBud', 'vsLy', 'por', 'pctRev', 'porVar']);

/** True when the month at `monthIndex` (0–11; 12 = Total) has actuals to show. */
export function monthHasActual(display: GridDisplay, monthIndex: number): boolean {
  if (monthIndex >= 12) return display.closedMonthSet.size > 0;
  const key = MONTH_KEYS[monthIndex];
  return !!key && display.closedMonthSet.has(key);
}
